<template>
  <ValidationObserver
    :id="id"
    ref="formularValidationObserver"
    v-slot="{ errors, invalid }"
    slim
  >
    <form
      ref="formular"
      class="needs-validation"
      :class="{ 'is-invalid': invalid }"
      novalidate
      @submit.prevent="fireSubmit"
    >
      <slot name="formHeader" />
      <slot />
      <slot name="formFooter" />
      <div v-if="$slots['formButtons']" class="row justify-content-end">
        <div class="col-auto d-flex gap-2 form-buttons">
          <slot name="formButtons" />
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import uniqid from "uniqid";

export default {
  components: {
    ValidationObserver
  },
  props: {
    id: {
      type: String,
      default: () => uniqid("Form-")
    }
  },
  methods: {
    async fireSubmit() {
      if (await this.$refs.formularValidationObserver.validate()) {
        this.$refs.formularValidationObserver.reset();
        this.$emit("submit");
      } else {
        this.$emit("invalid-form", this.$refs.formularValidationObserver);
      }
    },
    setErrorsIfExsists(apolloResponse) {
      // Graphql-/ Netzwerkfehler sind passiert
      // User bekommt ein Feedback durch den ApolloErrorLink
      if (apolloResponse.errors) {
        return false;
      }

      const responseResult = Object.values(apolloResponse.data)[0];
      let validResponse = true;
      if (this.hasValidationFeedback(apolloResponse)) {
        responseResult.feedback.forEach((feedback) => {
          this.$feedback(this.$t(feedback.code), {
            type: feedback.type.toLocaleLowerCase()
          });
          if (feedback.type.toLocaleLowerCase() === "error") {
            validResponse = false;
          }
        });
      }

      if (this.hasValidationErrors(apolloResponse)) {
        const mappedErrors = this.mapValidationErrors(
          responseResult.validationErrors
        );
        this.setValidationErrors(mappedErrors);
        validResponse = false;
      }

      return validResponse;
    },
    hasValidationErrors(apolloResponse) {
      const responseResult = Object.values(apolloResponse.data)[0];
      return (
        responseResult &&
        responseResult.hasOwnProperty("validationErrors") &&
        responseResult.validationErrors.length
      );
    },
    hasValidationFeedback(apolloResponse) {
      const responseResult = Object.values(apolloResponse.data)[0];
      return (
        responseResult &&
        responseResult.hasOwnProperty("feedback") &&
        responseResult.feedback.length
      );
    },
    setValidationErrors(errors) {
      this.$refs.formularValidationObserver.setErrors(errors);
    },
    mapValidationErrors(validationErrors) {
      const mappedErrors = {};
      if (validationErrors && validationErrors.length) {
        validationErrors.forEach(
          (error) => (mappedErrors[error.path] = this.$t(error.code))
        );
      }
      return mappedErrors;
    },
    resetFormValidation() {
      requestAnimationFrame(() => {
        this.$refs.formularValidationObserver.reset();
      });
    }
  }
};
</script>
